module.exports = __webpack_public_path__ + "static/img/logo_48.3b03321.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_48.png
// module id = x7EN
// module chunks = 1